module.exports = __webpack_public_path__ + "img/menu.751e2099.svg";